// Número único de WhatsApp de Avanza (formato internacional, sin "+").
export const WHATSAPP_NUMBER = '34653933298'

// Enlace de WhatsApp con un mensaje prefijado que incluye el contexto de la página.
export function buildWhatsappUrl (route) {
  let text = 'Hola, os escribo desde la web de Avanza.'
  if (route && route.name === 'Inmueble' && route.params && route.params.id) {
    text = `Hola, me interesa este inmueble de la web de Avanza: ${window.location.href}`
  } else if (route && route.name === 'Sell') {
    text = 'Hola, quiero vender mi inmueble con Avanza.'
  }
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`
}
